<template>
    <span
        class="inline-flex font-medium rounded-full text-center text-xs px-2 py-0.5 border"
        :class="classes"
    >
        {{ label }}
    </span>
</template>

<script>
    export default {
        name: "StatusBadge",

        props: {
            label: {
                type: String,
                required: true
            },
            color: {
                type: String,
                default: "slate"
            }
        },

        computed: {
            classes() {
                return [
                    `bg-${this.color}-100`,
                    `text-${this.color}-500`,
                    `border-${this.color}-500`
                ]
            }
        }
    }
</script>